/** @jsxImportSource @emotion/react */
import { Button, DialogContent, Divider, Grid, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useContext, useState } from 'react';

import Popup, { PopupTitle } from '../../Components/CustomPopup';
import ElevatedGrid from '../../Components/ElevatedGrid';
import PageLayout from '../Layout/PageLayout';
import { useEffect } from 'react';
import { Il8nContext } from '../../Helper/i18n';
import config from '../../config';
import { useNavigate } from 'react-router-dom';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import axios from '../../Helper/Axios/interceptor';
import BrokeragePlan from './BrokeragePlan';
import DepositoryScheme from './DepositoryScheme';
import { detailChecker, steps, getGlobalSteper } from '../../Helper/AppStepperData';
import { updateStepper } from '../../Helper/Redux/reducers/upDown';
import { useDispatch, useSelector } from 'react-redux';
import FullScreenLoader from '../../Components/FullScreenLoader';
import getCookie from '../../Helper/Cookies/cookies';
import SubbrokerBrokerage from './SubbrokerBrokerage';
import { getObjections, objectionNavigation, setObjections } from '../../Helper/Functions';

function PlanDetails(props) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const isTabScreen = useMediaQuery(theme.breakpoints.down('lg'))
    const stepper = useSelector(state => state.storeState.stepper)
    const store = useSelector(state => state.storeState.stage)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [responseStatus, setResponseStatus] = useState({})
    const [brokeragePlans, setBrokeragePlans] = useState()
    const [selectedPlan, setSelectedPlan] = useState()
    const [selectedDPCharge, setSelectedDPCharge] = useState()
    const [paymentDone, setPaymentDone] = useState(false)
    const [loading, setLoading] = useState(false);
    const [openMarginDetailsPopup, setOpenMarginDetailsPopup] = useState(false)
    const [openDepositoryDetailsPopup, setOpenDepositoryDetailsPopup] = useState(false)
    const subBroker = getCookie("referalCode");
    const [objectionState, setObjectionState] = useState({"isObjection" : false, "objections" : []})
    const [selectedSchemeId, setSelectedSchemeId] = useState('');
    const [dpCharge,setDpCharge] = useState('')
    const localeText = useContext(Il8nContext)
    
    useEffect(() => {
        getBrokeragePlan()
        getStageDetails()
        let objectionValue = getObjections()
        let objections = objectionValue?.filter(objection=>objection.navigationPath == "/PlanDetails")
        if(objections?.length>0){
            objections = objections.map(objection => { 
                return {
                    "objectionDescription" : objection.objectionDescription, 
                    "remark": objection.remark
                }
            })

            objectionValue = objectionValue.map(objection=> { 
                if(objection.navigationPath == "/PlanDetails"){
                    objection.isNavigationDone = true; 
                }
                return objection 
            })

            setObjections(objectionValue)
            setObjectionState({ isObjection : true, objections })
        }
        
    }, [])

    useEffect(()=>{
        setSelectedSchemeId(selectedDPCharge?.depositorySchemeId)
        },
    [selectedDPCharge])

    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const getStageDetails = () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL + config.stageDetails)
            .then(resp => {
                if (resp.data.success) {
                    !(stepper?.length) && dispatch(updateStepper(getGlobalSteper(resp.data.success.stageDetilasList)))
                    getBrokerageDetails(resp.data.success.stageDetilasList)
                } else {
                    throw new Error()
                }
            }).catch((err) => {
                getBrokerageDetails()
                console.log(err.message)
            })
    }

    const getBrokerageDetails = (stagingData) => {
        axios.get(process.env.REACT_APP_API_URL + config.getBrokerageDetails)
            .then(resp => {
                if (resp.data.success) {
                    setLoading(false)
                    setSelectedDPCharge({ depositorySchemeId: resp.data.success[0].depositorySchemeID, depositorySchemeName: resp.data.success[0].depositorySchemeName })
                    setSelectedPlan({ id: resp.data.success[0].planId })
                    if (detailChecker(stagingData, 8)) {
                        setPaymentDone(true)
                    }
                }
                else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                console.log(err.message)
            })
    }

    const getBrokeragePlan = () => {
        axios.get(process.env.REACT_APP_API_URL + config.getBrokeragePlans)
            .then(resp => {
                if (resp.data.success) {
                    setBrokeragePlans(resp.data.success)
                } else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                console.log(err.message)
            })
    }

    const handleBrokeragePlanSelection = (plan) => {
        setSelectedPlan(plan)
    }


    const handleDPPlanSelection = (dpScheme, id) => {
        if (subBroker) {
            setSelectedDPCharge(dpScheme)
        }
        else {
            if (selectedPlan?.id  && id == dpScheme?.depositorySchemeId) {
                setSelectedDPCharge(dpScheme)
            }
                setSelectedDPCharge(dpScheme)
        }
    }

    const nextNavigation = () => {
        if(objectionState.isObjection){
            objectionNavigation(navigate)
        }
        else{
            dispatch(updateStepper({ step: 3, nestedStep: 3 }));
            navigate("/Upload")
        }
    }

    const submitBrokerageDetails = () => {
        if (selectedDPCharge && selectedDPCharge.depositorySchemeId && selectedDPCharge.depositorySchemeName && selectedPlan?.id) {
            setLoading(true)
            let payload = {
                depositorySchemeID: selectedDPCharge.depositorySchemeId,
                depositorySchemeName: selectedDPCharge.depositorySchemeName,
                isCustomPlan: 0,
                planId: selectedPlan.id
            }
            axios.post(process.env.REACT_APP_API_URL + config.brokerageDetails, payload)
                .then(resp => {
                    setLoading(false)
                    if (resp.data.success) {
                        nextNavigation()
                    } else {
                        throw new Error(resp.data.error)
                    }
                }).catch((err) => {
                    setLoading(false)
                    setResponseStatus({ "message": err.message, "type": "error" })
                    setSnackBarOpen(true)
                })
        }
        else {
            setResponseStatus({ "message": localeText?.planDetailsSelectBrokerage, "type": "error" })
            setSnackBarOpen(true)
        }
    }

    const getDPChargeUI = () => {
        return <>
            <Grid item xs={12}>
                <Typography variant="body1" fontWeight={"bold"} color="#525D72" css={{ margin: "10px 0px", textAlign: isSmallScreen ? "center" : "none" }}>
                    {localeText?.planDetailsChargesforDepository}
                </Typography>
            </Grid>
            <Grid container item xs={12} alignItems="center" justifyContent={"space-around"}>
                {brokeragePlans?.depositoryschememaster?.map(dpScheme => (
                    <DepositoryScheme
                        key={dpScheme.depositorySchemeId}
                        paymentDone={paymentDone}
                        dpScheme={dpScheme}
                        isSmallScreen={isSmallScreen}
                        selectedPlan={selectedPlan}
                        selectedDPCharge={selectedDPCharge}
                        handleDPPlanSelection={handleDPPlanSelection}
                        toggleDepositoryDetailsPopup={toggleDepositoryDetailsPopup}
                        openDepositoryDetailsPopup={openDepositoryDetailsPopup}
                        isSelected={selectedSchemeId === dpScheme.depositorySchemeId}
                    />
                ))}
            </Grid>
        </>
    }

    const toggleMarginDetailsPopup = () => {
        setOpenMarginDetailsPopup(!openMarginDetailsPopup)
    }

    const toggleDepositoryDetailsPopup = (data) => {
        setDpCharge(data)
        setOpenDepositoryDetailsPopup(!openDepositoryDetailsPopup)
    }

    const getMarginDetailsView = () => {
        return(
            <Grid container>
                <Grid item xs={12} css={{backgroundColor:"#074B55"}}>
                    <Typography color="white" fontWeight={"bold"}>
                        {"BROKERAGE DETAILS"}
                    </Typography>
                </Grid>
                <Grid item xs={12} css={{backgroundColor:"#E5E5E5"}}>
                    <Typography color="black" fontWeight={"bold"}>
                        {`${"Margin Collected: "}${selectedPlan.mAmount} (${selectedPlan.name})`}
                    </Typography>
                </Grid>
                <Grid item xs={12} css={{backgroundColor:"#074B55"}}>
                    <Typography color="white" fontWeight={"bold"}>
                        {"BROKERAGE PLAN"}
                    </Typography>
                </Grid>
                <Grid item xs={12} css={{backgroundColor:"#E5E5E5"}}>
                    <Typography color="black" fontWeight={"bold"}>
                        {"EQUITY SEGMENT"}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#78C4CE", padding:"0px"}}></TableCell>
                                <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#96DAE3", textAlign:"center", padding:"0px", fontWeight: "bold"}} colSpan={2}>{"Equity/Futures/Currency"}</TableCell>
                                <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#96DAE3", textAlign:"center", padding:"0px", fontWeight: "bold"}} colSpan={2}>{"Equity Delivery"}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#C1C1C1", padding:"0px"}}></TableCell>
                                <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{"%"}</TableCell>
                                <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px", fontWeight: "bold"}}>{"Min (Paisa)"}</TableCell>
                                <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{"%"}</TableCell>
                                <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px", fontWeight: "bold"}}>{"Min (Paisa)"}</TableCell>
                            </TableRow>                        
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#C1C1C1", textAlign:"center", padding:"0px", fontWeight: "bold"}}>{"1st LEG"}</TableCell>
                                <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.t1stLegMxPerc}</TableCell>
                                <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.t1stLegMPaisa}</TableCell>
                                <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.delvMxPerc}</TableCell>
                                <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.delvMPaisa}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#C1C1C1", textAlign:"center", padding:"0px", fontWeight: "bold"}}>{"2nd LEG"}</TableCell>
                                <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.t2ndLegMxPerc}</TableCell>
                                <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.t2ndLegMPaisa}</TableCell>
                                <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.delvMxPerc}</TableCell>
                                <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.delvMPaisa}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Grid>
                <Grid item xs={12} css={{backgroundColor:"#E5E5E5"}}>
                    <Typography color="black" fontWeight={"bold"}>
                        {"OPTIONS (per lot)"}
                    </Typography>
                </Grid>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#C1C1C1", textAlign:"center", padding:"0px"}}></TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px", fontWeight: "bold"}}>{"Index(₹)"}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px", fontWeight: "bold"}}>{"Stock(₹)"}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px", fontWeight: "bold"}}>{"Bank Nifty(₹)"}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px", fontWeight: "bold"}}>{"Currency(₹)"}</TableCell>
                        </TableRow>                        
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#C1C1C1", textAlign:"center", padding:"0px", fontWeight: "bold"}}>{"1st LEG"}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.eqOptIndxMPerLotPaisa}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.eqOptStckMxPerLotPaisa}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.bNifty}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.currOptMPerLotPaisa}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#C1C1C1", textAlign:"center", padding:"0px", fontWeight: "bold"}}>{"2nd LEG"}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.eqOptIndxMPerLotPaisa}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.eqOptStckMxPerLotPaisa}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.bNifty}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.currOptMPerLotPaisa}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Grid item xs={12} css={{backgroundColor:"#E5E5E5"}}>
                    <Typography color="black" fontWeight={"bold"}>
                        {"COMMODITY SEGMENT"}
                    </Typography>
                </Grid>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#78C4CE", padding:"0px"}}></TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#96DAE3", textAlign:"center", padding:"0px", fontWeight: "bold"}} colSpan={2}>{"Futures"}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#96DAE3", textAlign:"center", padding:"0px", fontWeight: "bold"}}>{"Options"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#C1C1C1", padding:"0px"}}></TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{"%"}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px", fontWeight: "bold"}}>{"Min (Paisa)"}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{"₹"}</TableCell>
                        </TableRow>                        
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#C1C1C1", textAlign:"center", padding:"0px", fontWeight: "bold"}}>{"1st LEG"}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.t1stLegMxPerc}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.t1stLegMPaisa}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.eqOptIndxMPerLotPaisa}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell css={{border:"1px solid #AFAFAF", backgroundColor: "#C1C1C1", textAlign:"center", padding:"0px", fontWeight: "bold"}}>{"2nd LEG"}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.t2ndLegMxPerc}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.t2ndLegMPaisa}</TableCell>
                            <TableCell css={{border:"1px solid #AFAFAF", textAlign:"center", padding:"0px"}}>{selectedPlan.eqOptIndxMPerLotPaisa}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Grid>
        )
    }

    const DPChargesDetails = {
        'Lifetime AMC 1250':{
           "Charges":"1250",
           "withinTradebulls": 11,
           "outsideTradebulls":21,
           "pledgeCharges":25,
           "marginPledgeCharges":12,
           "marginPledgeChargesForMTF":24, 
           "dematerilization":10,
           "postalCharges":50,
           "rematerialazation":"Actual CDSL chrages",
           "postalChargesForRematerialazation":30,
           "dematRejection":30
        },
        'Lifetime AMC 550':{
            "Charges":"550",
            "withinTradebulls": 25,
           "outsideTradebulls":35,
           "pledgeCharges":50,
           "marginPledgeCharges":12,
           "marginPledgeChargesForMTF":24, 
           "dematerilization":20,
           "postalCharges":60,
           "rematerialazation":"Actual CDSL chrages",
           "postalChargesForRematerialazation":60,
           "dematRejection":30
        },
        'Investor 300':{
            "Charges":"300",
           "withinTradebulls": 11,
           "outsideTradebulls":21,
           "pledgeCharges":25,
           "marginPledgeCharges":12,
           "marginPledgeChargesForMTF":24, 
           "dematerilization":10,
           "postalCharges":50,
           "rematerialazation":"Actual CDSL chrages",
           "postalChargesForRematerialazation":30,
           "dematRejection":30
        },
        'BSDA':{
            "Charges":"",
           "withinTradebulls": 11,
           "outsideTradebulls":21,
           "pledgeCharges":25,
           "marginPledgeCharges":12,
           "marginPledgeChargesForMTF":24, 
           "dematerilization":10,
           "postalCharges":50,
           "rematerialazation":"Actual CDSL chrages",
           "postalChargesForRematerialazation":30,
           "dematRejection":""
        },
        'HNI CORPORATE':{
            "Charges":"1000",
           "withinTradebulls": 11,
           "outsideTradebulls":21,
           "pledgeCharges":25,
           "marginPledgeCharges":12,
           "marginPledgeChargesForMTF":24, 
           "dematerilization":10,
           "postalCharges":30,
           "rematerialazation":"Actual CDSL chrages",
           "postalChargesForRematerialazation":30,
           "dematRejection":30  
        }
    }

    const getDepositoryDetailsView = () => {
        const selectedCharges = DPChargesDetails[dpCharge?.depositorySchemeName];
        return (
            <div style={{ paddingBottom: "5px" }}>
                <Typography style={{ textAlign: "center", fontWeight: "700", fontSize: "1.8rem", marginBottom: "10px" }}>{dpCharge?.depositorySchemeName}</Typography>
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow style={{ backgroundColor: "#00b6ce" }} >
                                <TableCell rowSpan={2} colSpan={2} style={{ color: '#000000', textAlign: "center", fontWeight: "bold", borderLeft: "1px solid #00b6ce" }}>Services</TableCell>
                                <TableCell style={{ color: '#000000', textAlign: "center", border: "1px solid #ffffff", width: "230px", borderRight: "1px solid #00b6ce"  }} ><strong>Charges</strong> (Exclusive of GST)*</TableCell>
                            </TableRow>
                            <TableRow style={{ backgroundColor: "#787A7A" }}>
                                {dpCharge?.depositorySchemeName === "BSDA" ? "" : <TableCell sx={{ color: '#FFF', fontWeight: 'bold', border: "1px solid #ffffff", textAlign: "center", verticalAlign: "middle", borderRight: "1px solid #787A7A" }}>{selectedCharges?.Charges}</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow >
                                <TableCell rowSpan={3} sx={{ border: "1px solid #AFAFAF", verticalAlign: "top" }}>1.</TableCell>
                                <TableCell css={{ border: "1px solid #AFAFAF", backgroundColor: "#e4e4e4", width: "290px" }}>{localeText?.deliveriesDebitDP}</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF", backgroundColor: "#e4e4e4" }}></TableCell>
                            </TableRow>
                            <TableRow >
                                <TableCell sx={{ border: "1px solid #AFAFAF" }}>{localeText?.withinTradebulls}</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF", textAlign: "center" }}>₹ {selectedCharges?.withinTradebulls}/-</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ border: "1px solid #AFAFAF" }}>{localeText?.outSideTradebulls}</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF", textAlign: "center" }}>₹ {selectedCharges?.outsideTradebulls}/-</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ border: "1px solid #AFAFAF", verticalAlign: "top" }}>2.</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF" }}>{localeText?.pledgeCharges}</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF", textAlign: "center" }}>₹ {selectedCharges?.pledgeCharges}/-</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ border: "1px solid #AFAFAF", verticalAlign: "top" }}>3.</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF" }}>{localeText?.marginPledge}</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF", textAlign: "center" }}>₹ {selectedCharges?.marginPledgeCharges}/-</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ border: "1px solid #AFAFAF", verticalAlign: "top" }}>4.</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF" }}>{localeText?.marginPledgeMTF}</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF", textAlign: "center" }}>₹ {selectedCharges?.marginPledgeChargesForMTF}/-</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell rowSpan={2} sx={{ border: "1px solid #AFAFAF", verticalAlign: "top" }}>5.</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF" }}>{localeText?.dematerialization}</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF", textAlign: "center" }}>₹ {selectedCharges?.dematerilization}/-</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ border: "1px solid #AFAFAF" }}>{localeText?.postalCharges}</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF", textAlign: "center" }}>₹ {selectedCharges?.postalCharges}/-</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell rowSpan={2} sx={{ border: "1px solid #AFAFAF", verticalAlign: "top" }}>6.</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF" }}>{localeText?.rematerialization}</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF", textAlign: "center" }}>{selectedCharges?.rematerialazation}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ border: "1px solid #AFAFAF" }}>{localeText?.postalCharges}</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF", textAlign: "center" }}>₹ {selectedCharges?.postalChargesForRematerialazation}/-</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ border: "1px solid #AFAFAF", verticalAlign: "top" }}>7.</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF" }}>{localeText?.dematRejection}</TableCell>
                                <TableCell sx={{ border: "1px solid #AFAFAF", textAlign: "center" }}>{selectedCharges?.dematRejection ? `₹ ${selectedCharges?.dematRejection}/-` : "--"}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        )
    }
    return (
        <>
            <PageLayout css={{ overflowY: "scroll" }} showSidebar calculateHeight={isSmallScreen ? true : false} isObjectionScreen={objectionState.isObjection}
                breadcrumb={{ show: true, steps: steps[2].nestedSteps, step: 3, nestedStep: 2 }}>
                <ElevatedGrid >
                    <Grid container item alignItems={"start"} >
                        <Grid container item alignItems={"center"}>
                            {paymentDone && <Grid item xs={12}>
                                <Typography css={{
                                    "color": "white",
                                    "text-align": "center",
                                    "background": "#1DA838",
                                    "border-radius": "5px",
                                    "padding": "10px 0px",
                                    "font-size": "16px",
                                    "width": "100%",
                                    "border": "#1DA838 1px solid",
                                    "margin-bottom": "10px"
                                }}>
                                    {"Payment already done"}
                                </Typography>
                            </Grid>}
                            {objectionState.isObjection && <Grid item xs={12} css={{ padding: "10px", color: "white", backgroundColor: "lightcoral", borderRadius: "10px", margin: "10px 0px" }}>
                                {objectionState.objections.map((objection, i) =>
                                    <>
                                        <Typography align="center" display="inline" variant="body2" fontWeight={"bold"}>
                                            {localeText?.profileObjection} {objection.objectionDescription || "--"} {localeText?.profileObjectionRemark} {objection.remark || "--"} <br />
                                        </Typography>
                                        {i > 0 && <Divider />}
                                    </>
                                )}
                            </Grid>}
                            <Grid item xs={12}>
                                <Typography display="inline" fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                                    {localeText?.planDetailsTitle}
                                </Typography>
                            </Grid>
                            <Grid container item spacing={1} css={{ marginTop: "10px" }} >
                                <Grid item xs={12}>
                                    <Typography variant="body1" fontWeight={"bold"} color="#525D72" css={{ marginBottom: "10px" }}>
                                        {localeText?.planDetailsSelectBrokeragePlan}
                                    </Typography>
                                </Grid>
                                {subBroker ?
                                    <SubbrokerBrokerage brokeragePlans={brokeragePlans} selectedPlan={selectedPlan} handleBrokeragePlanSelection={handleBrokeragePlanSelection}
                                        selectedDPCharge={selectedDPCharge} toggleDepositoryDetailsPopup={toggleDepositoryDetailsPopup} handleDPPlanSelection={handleDPPlanSelection}
                                    />
                                    :
                                    <>
                                        <Grid container item xs={12}  alignItems="flex-start" justifyContent={isTabScreen ?"flex-start":''}>
                                            {brokeragePlans?.brokerageplan?.map(plan => <BrokeragePlan paymentDone={paymentDone} plan={plan} isSmallScreen={isSmallScreen} getDPChargeUI={getDPChargeUI} selectedPlan={selectedPlan} handleBrokeragePlanSelection={handleBrokeragePlanSelection} toggleMarginDetailsPopup={toggleMarginDetailsPopup} />)}
                                        </Grid>
                                        {!isSmallScreen &&
                                            <>
                                                <Grid item xs={12} css={{ marginTop: "25px" }}>
                                                    <Divider />
                                                </Grid>
                                                {getDPChargeUI()}
                                            </>
                                        }
                                    </>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </ElevatedGrid>
                {!isSmallScreen && <Grid item css={{ marginTop: "40px" }}>
                    <Button variant='contained' color="primary" onClick={submitBrokerageDetails}>
                        {localeText?.planDetailsNextBtn}
                    </Button>
                </Grid>}
            </PageLayout>

            <Popup
                open={openMarginDetailsPopup}
                maxWidth={"sm"}
            >
                <PopupTitle onClose={toggleMarginDetailsPopup} />
                <DialogContent css={{ textAlign: "center", margin: "0px 10px" }}>
                    {openMarginDetailsPopup && getMarginDetailsView()}
                </DialogContent>
            </Popup>

            <Popup
                open={openDepositoryDetailsPopup}
                maxWidth={"sm"}
            >
                <PopupTitle onClose={toggleDepositoryDetailsPopup} />
                <DialogContent css={{ textAlign: "center" }}>
                    {openDepositoryDetailsPopup && getDepositoryDetailsView()}
                </DialogContent>
            </Popup>

            {loading && <FullScreenLoader />}
            {isSmallScreen && <Grid item css={{ position: "fixed", textAlign: "center", padding: "15px", width: "100%", bottom: 0, boxShadow: "0px -15px 30px #00000029", backgroundColor: "#FFFFFF", zIndex: "1" }}>
                <Button variant='contained' color="primary" onClick={submitBrokerageDetails}>
                {localeText?.planDetailsNextBtn}
                </Button>
            </Grid>}
            {
                responseStatus && responseStatus.message && <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackBarOpen}
                    autoHideDuration={5000}
                    onClose={handleSnackBarClose}
                >
                    <MySnackbarContentWrapper
                        onClose={handleSnackBarClose}
                        variant={responseStatus.type}
                        message={responseStatus.message}
                    />
                </Snackbar>
            }
        </>
    );
}

export default PlanDetails;